export const deletedDevices = {
    read(options) {
        return $.getJSON(AdminRoutes.adminDeletedDevicesPath(options));
    }
}